{
    "webhooks": {
        "newWebhook": "Ny Webhook",
        "name": "Webhook-navn",
        "description": "Beskrivelse",
        "editWebhook": "Rediger Webhook",
        "webhookDetails": "Webhook-detaljer",
        "messages": {
            "deleteWebhookConfirmation": "Vil du slette webhooken {webhookName}?",
            "deleteWebhookSuccess": "Webhook ble slettet",
            "webhookNameExists": "Webhook-navn {webhookName} eksisterer allerede!",
            "webhookNameRequired": "Webhook-navn er påkrevd",
            "workflowRequired": "Velg en arbeidsflyt fra rullegardinmenyen",
            "copied": "Kopiert til utklippstavlen",
            "copyError": "Kunne ikke kopiere",
            "success": "Webhook ble lagret",
            "errorOccurred": "En feil oppstod ved lagring av webhook"
        },
        "title": "Webhooks",
        "webhookName": "Webhook-navn",
        "workflow": "Arbeidsflyt",
        "webhookUrl": "Webhook URL",
        "tokenUrl": "Webhook-URL (med token)",
        "triggerHelp": "Send en POST-forespørsel til URL-en nedenfor for å utløse denne arbeidsflyten.",
        "basicAuthFallback": "Bruk Basic Auth i stedet",
        "username": "Brukernavn",
        "password": "Passord",
        "token": "Token",
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "restrictedAccess": "Begrenset tilgang",
        "invalidWorkflow": "Ugyldig arbeidsflyt",
        "activateSuccess": "Webhook ble aktivert",
        "deactivateSuccess": "Webhook ble deaktivert",
        "createWebhook": "Opprett Webhook",
        "noWebhooks": "Ingen webhooks konfigurert for denne arbeidsflyten"
    },
    "groups": {
        "title": "Grupper",
        "noGroupedFields": "Ingen grupperte felt funnet",
        "newGroup": "Ny Gruppe",
        "editGroup": "Rediger Gruppe",
        "groupName": "Gruppenavn",
        "workflows": "Arbeidsflyter",
        "roles": "Roller",
        "selectWorkflows": "Velg Workflows",
        "tooltip": "Velg rekkefølgen på workflows som skal vises i VXL Live",
        "selected": "Valgte Workflows",
        "workflowName": "Workflow Navn",
        "createdByUser": "Opprettet Av",
        "modifiedBy": "Endret Av",
        "created": "Opprettet",
        "modified": "Endret",
        "messages": {
            "groupNameRequired": "Gruppenavn er påkrevd.",
            "groupNameExists": "Gruppen {groupName} finnes allerede!",
            "groupNameCheckFailed": "Kunne ikke verifisere gruppenavnet. Prøv igjen.",
            "rolesRequired": "Minst én rolle må velges.",
            "deleteGroupConfirmation": "Er du sikker på at du vil slette gruppen '{groupName}'?",
            "deleteGroupSuccess": "Gruppen ble slettet.",
            "success": "Gruppen ble lagret.",
            "workflowsRequired": "Minst én arbeidsflyt må velges."
        }
    },
    "workflows": {
        "openReadOnly": "Åpne skrivebeskyttet",
        "readOnly": {
            "label": "Skrivebeskyttet",
            "description": "Denne trinnkonfigurasjonen kan ikke endres. Merk og kopier en verdi, eller kopier hele konfigurasjonen.",
            "copyConfiguration": "Kopier konfigurasjon",
            "copySuccess": "Trinnkonfigurasjonen ble kopiert til utklippstavlen.",
            "copyError": "Kunne ikke kopiere trinnkonfigurasjonen."
        },
         "active": "Aktiv Arbeidsflyt",
         "importWorkflow": "Importer Arbeidsflyt",
         "importWorkflowTooltip": "Når dette er valgt, er arbeidsflyten konfigurert til å importere/laste opp data fra et Excel-regneark ved kjøring. Arbeidsflyten vil behandle de opplastede dataene og utløse de tilknyttede API-ene. Disse API-ene kan utføre enten import- eller eksportoperasjoner avhengig av arbeidsflytens konfigurasjon.",
        "unsavedPopover": {
            "title": "Ulagrede endringer",
            "message": "Du har ulagrede endringer i arbeidsflyten \"{title}\". Vil du lagre arbeidsflyten?",
            "saveAndContinue": "Lagre og fortsett"
        },
        "addUserInstructions": "Legg til ny",
        "allWorkflows": "Alle Arbeidsflyter",
        "configurationExecutionKeys": "Konfigurasjonskjøringsnøkler ({current}/{maximum})",
        "keyName": "Navn",
        "expression": "JSONata-uttrykk",
        "addNewExecutionKey": "Ny nøkkel",
        "designFile": "Designfil",
        "designFileSaved": "Designfil oppdatert",
        "lookupWorkflow": "<strong>Oppslagsnavn:</strong> {lookup}   <strong>Arbeidsflytnavn:</strong> {workflow}",
        "type": "Arbeidsflyttype",
        "nameIsRequired": "Feltet er obligatorisk",
        "nameNotPermitted": "Du har ikke tillatelse til å opprette en arbeidsflyt med dette navnet",
        "nameHasSpecialChars": "Spesialtegn: / $ * ? {'{'} {'}'} [ ] & % er ikke tillatt",
        "validation": {
            "keyNameRequired": "Nøkkelnavn er påkrevd",
            "invalidExpression": "Ugyldig JSONata-uttrykk",
            "expressionRequired": "Uttrykk er påkrevd"
        },
        "api": {
            "addApi": "Legg til API",
            "alreadyExists": "eksisterer allerede!",
            "apiOptions": "API-Alternativer",
            "basedOnTransaction": "Basert på transaksjon",
            "code": "Kode",
            "componentSettings": "Komponent innstillinger",
            "connections": "Tilkoblinger",
            "constant": "Konstant",
            "critical": "Kritisk",
            "currentDate": "Nåværende Dato",
            "done": "Ferdig",
            "editElement": "Rediger element",
            "endRun": "Slutt Løp",
            "enterRows": "Skriv inn rader",
            "enterValue": "Skriv inn verdi",
            "environment": "Miljø",
            "fromApi": "Fra API",
            "fromClient": "Fra Client",
            "fromEvent": "From Event",
            "fromExcel": "Fra Excel",
            "fromTag": "fra Tag",
            "group": "Gruppe",
            "groupedBy": "Gruppert Etter",
            "includeGeneralTransactions": "Inkluder generelle Transaksjoner",
            "input": "Inngang",
            "inputs": "Innganger",
            "mapped": "Kartlagt",
            "max": "Maks",
            "maxRows": "Maks rader",
            "messages": {
                "configureOneTransaction": "API: Konfigurer minst én Transaksjon",
                "mandatoryFieldNotMapped": "API: Obligatorisk felt ikke kartlagt: {input}"
            },
            "name": "Navn",
            "output": "Produksjon",
            "outputs": "Utganger",
            "overview": "Oversikt",
            "pleaseEnterValue": "Skriv inn verdi",
            "program": "Program",
            "programName": "Program Navn",
            "runOn": "Kjør På",
            "select": "Select",
            "selectSource": "Velg Kilde",
            "source": "Kilde",
            "startRun": "Start Kjør",
            "transaction": "Transaksjon",
            "transactionName": "Transaksjon Navn",
            "view": "Utsikt",
            "workflowSpreadsheet": "Arbeidsflyt bruker regnearkdata?"
        },
        "notification": {
            "status": {
                "finished": "fullført",
                "started": "startet",
                "stepcomplete": "pågår",
                "failed": "feilet"
            },
            "view": "Vis",
            "workflow": "Arbeidsflyt {workflowName} {status}"
        },
          "runWorkflow": {
            "errors": {
                "hasError": "Arbeidsflyt inneholder konfigurasjonsfeil",
                "noEnvironments": "Ingen miljøer tilgjengelig for kjøring",
                "noConnections": "Ingen tilkoblinger tilgjengelig for kjøring",
                "connectionsLoadFailed": "Kunne ikke laste tilkoblinger",
                "environmentsLoadFailed": "Kunne ikke laste miljøer"
            },
            "execute": "Kjør",
            "tooltips": {
                "openLookupDialog": "Åpne oppslagsdialog"
            }
        },
        "cancelEditor": "Avbryt",
        "clientConfig": {
            "buttonDefaultText": "Kjør",
            "descriptionDefaultText": "Beskrivelse",
            "legacyDescriptionDefaultText": "Description",
            "legacyTitleDefaultText": "Untitled",
            "titleDefaultText": "Ny mal"
        },
        "client": {
            "addFilterInput": "Legg til filterinngang",
            "addInput": "Legg til input",
            "apiDetails": "API Detaljer",
            "browseControl": "Bla gjennom kontroll",
            "buttonText": "Knapptekst",
            "changeText": "Endre tekst",
            "clientConfiguration": "Klient konfigurasjon",
            "clientSettings": "Klientinnstillinger",
            "customRequired": "Gjør obligatorisk",
            "dateField": "Datofelt",
            "defaultValue": "Standardverdi",
            "fields": "Enger",
            "input": "Input",
            "lookup": "Se opp",
            "placeholder": "Plassholder",
            "settings": "Innstillinger",
            "tagField": "Tag",
            "textField": "Tekstfelt",
            "title": "Klient",
            "tooltip": "Verktøytips",
            "type": "Type"
        },
        "closeConfirmation": "Vil du lagre ventende endringer?",
        "closeConfirmationTitle": "Vennligst bekreft",
        "closeEditor": "Lukk",
        "code": {
            "codeEditor": "Code editor"
        },
        "component": "Komponent",
        "componentSettings": "Komponent innstillinger",
        "components": "Komponenter",
        "connection": "Forbindelse",
        "createdBy": "Created by",
        "createdDate": "Opprettelsesdato",
        "dataLake": {
            "title": "Data lake",
            "connectionId": "Tilkobling",
            "connectionPlaceholder": "Velg eller skriv inn en tilkoblings-ID...",
            "endpoint": "Endpoint-URL",
            "endpointPlaceholder": "https://api.example.com/path",
            "body": "Spørring",
            "bodyPlaceholder": "Skriv inn spørringen din...",
            "advanced": "Avansert",
            "saveAsFile": "Lagre utdata som fil i tillegg"
        },
        "fileUploader": {
            "messages": {
                "connectionRequired": "Tilkobling er påkrevd",
                "itemRequired": "Sti er påkrevd"
            },
            "title": "Filopplaster",
            "connection": "Tilkobling",
            "webUrl": "Sti",
            "browse": "Bla gjennom"
        },
        "transformerMorph": {
            "inputOrTemplateMissing": "Vennligst oppgi inndata og jsonata-mal",
            "title": "Transform",
            "input": "Inndata",
            "output": "Utdata",
            "help": "Lær JSONata-syntaks",
            "executionId": "Utførelses-ID for arbeidsflyt",
            "executionIdPrompt": "Last inn eksempeldata og simuler $context med faktiske verdier fra en arbeidsflytutførelse",
            "transformation": "JSONata-uttrykk",
            "loadExecution": "Last inn",
            "executionIdSuccessMessage": "Data lastet inn for utførelses-ID {executionId}",
            "noExecutionFound": "Ingen arbeidsflytutførelse funnet",
            "executionIdErrorMessage": "Feil ved lasting av utførelse",
            "copyToClipboard": "Kopier til utklippstavle",
            "copySuccessMessage": "JSONata-uttrykk kopiert til utklippstavle",
            "copyErrorMessage": "Feil ved kopiering av JSONata-uttrykk til utklippstavle"
        },
        "saveError": "Feil ved lagring av arbeidsflyt",
        "genericFilter": {
            "filterFieldPlaceholder": "Angi {fact} for å filtrere"
        },
        "genericCode": {
            "title": "Stegkoderedigerer"
        },
        "genericApi": {
            "title": "Rest API",
            "version": "Versjon",
            "versionDescription": "Komponentversjon",
            "connection": "Bruk tilkobling",
            "connectionId": "Tilkobling",
            "connectionPlaceholder": "Velg eller skriv inn en tilkoblings-ID...",
            "endpoint": "Endpoint-URL",
            "endpointPlaceholder": "https://api.example.com/path",
            "method": "HTTP-metode",
            "methodWarning": "Ukjent metode. Forventet en standard HTTP-metode eller et handlebars-uttrykk",
            "headers": "Headers",
            "addHeader": "Legg til header",
            "headerKey": "Nøkkel",
            "headerValue": "Verdi",
            "bodyMode": "Forespørselskropp",
            "bodyModeOption": {
                "bodyPath": "Body path",
                "body": "Body"
            },
            "bodyPathDescription": "Referer data fra et tidligere steg",
            "bodyDescription": "Definer forespørselskroppen",
            "bodyPathLabel": "JSONata body path-uttrykk",
            "bodyLabel": "Forespørselskropp JSON",
            "advanced": "Avansert",
            "skipIfExpression": "Hopp over hvis uttrykk",
            "skipIfExpressionDescription": "Et JSONata-uttrykk som, hvis det evalueres til sant, hopper over dette steget",
            "forEach": "For hver",
            "forEachDescription": "Sti til en array fra et tidligere steg å iterere over (f.eks. body.records)",
            "parallel": "Parallelle kjøringer",
            "parallelDescription": "Antall samtidige forespørsler som kjøres parallelt (maks 20)"
        },
        "runtimeConfig": {
            "title": "Konfigurer kjøringsmiljøer",
            "connectionAliases": "Tilkoblings-aliaser",
            "connectionAliasesHelp": "Hvert system løses ved kjøring til tilkoblingen som er tilordnet for det valgte miljøet.",
            "alias": "System",
            "aliasPlaceholder": "Legg til et annet system",
            "aliasValidation": "Kun små bokstaver, tall og understrek tillatt",
            "aliasDuplicate": "Dette systemet finnes allerede",
            "addAlias": "Legg til system",
            "environments": "Miljøer",
            "default": "Standard",
            "setDefault": "Angi som standard",
            "connections": "Tilkoblingsmappinger",
            "selectConnection": "Velg tilkobling...",
            "noAliasesYet": "Ingen tilkoblings-aliaser definert ennå. Legg til aliaser ovenfor først.",
            "variables": "Variabler",
            "variableKey": "Nøkkel",
            "variableValue": "Verdi",
            "addEnvironmentPlaceholder": "Legg til miljø...",
            "emptyState": "Legg til et miljø for å komme i gang. Tilkoblinger oppdages automatisk.",
            "noDefinitionError": "Arbeidsflyten har ingen definisjon, kan ikke lagre."
        },
        "deleteAPI": "Slett API",
        "deleteComponent": "Slett komponent",
        "deleteItem": "Er du sikker på at du vil slette \"{workflowName}\"?",
        "deleteItemFromDashboard": "Er du sikker på at du vil slette \"{workflowName}\"? Denne arbeidsflyten er koblet til Dashbordet og {widgetCount} {widgetText}.",
        "deleteConfirmation": "Slett Bekreftelse",
        "deleteItemAPI": "Vil du slette API-en {APIName}?",
        "deleteUserInstructions": "Slett",
        "deleteUserInstructionsConfirmationMessage": "Denne handlingen vil slette brukerinstruksjonene permanent. Er du sikker på at du vil fortsette?",
        "deleteUserInstructionsConfirmationTitle": "Bekreft sletting",
        "deleteLastStepError": "Det siste arbeidsflyttrinnet kan ikke slettes. \n Legg til et nytt trinn først, eller slett hele arbeidsflyten",
        "description": " Workflow Beskrivelse",
        "editor": {
            "addComponent": "Legg til Komponent",
            "api": "API",
            "code": "Kode",
            "componentToStartWorkflow": "Velg en Komponent for å starte fra arbeidsflyt",
            "converter": "Converter",
            "createFromScratch": "...Eller Lag fra scratch",
            "createFromTemplate": "Opprett fra Mal...",
            "dataLake": "Data lake",
            "database": "Database",
            "email": "Email",
            "excel": "Excel",
            "exportToExcel": "Exporter from M3",
            "fileLoader": "File Loader",
            "filter": "Filter",
            "genericFilter": "Generisk Filter",
            "importToAPI": "Importer til M3",
            "lookup": "Lookup",
            "notification": "Varsler",
            "restApi": "Rest API",
            "sms": "SMS",
            "storeApiToTable": "Lagre data fra M3 til Table",
            "table": "Tabell",
            "tableUpdater": "Table updater",
            "transform": "Transform",
            "trigger": "Trigger",
            "widget": "Widget"
        },
        "email": {
            "sourceType": {
                "NONE": "Ingen",
                "FILE": "Genererte filer",
                "DATA": "Rådata"
            },
            "noFileSourceSteps": "Ingen steg før dette kan produsere en fil",
            "sourceTypeHint": {
                "FILE": "Legg ved en fil produsert av et kompatibelt tidligere steg (f.eks. {stepNames})",
                "DATA": "Legg ved rådata fra et tidligere steg i JSON-format"
            },
            "body": "Melding",
            "sourceStep": "Kildesteg for data",
            "noSourceSteps": "Ingen kildesteg som kan produsere data er tilgjengelige",
            "addresses": "Adresser",
            "content": "E-postinnhold",
            "attachment": "Vedlegg",
            "isHTML": "HTML",
            "htmlHelp": "Bør velges hvis brukeren bruker HTML-kode i Transform- eller Email-steg.",
            "editorTabs": {
                "visual": "Visuell editor",
                "html": "HTML-editor",
                "preview": "Forhåndsvisning"
            },
            "toolbar": {
                "heading": "Overskrift",
                "subheading": "Underoverskrift",
                "normal": "Normal"
            },
            "attachmentIndicators": {
                "none": "--",
                "data": "<>"
            },
            "subject": "Emne",
            "invalidEmail": "Ugyldig e-post",
            "to": "Til",
            "addCc": "Legg til cc-adresser",
            "cc": "Cc",
            "bcc": "Bcc",
            "addBcc": "Legg til bcc-adresser",
            "title": "E-postavsender",
            "fieldNames": {
                "toAddress": "Til-adresse",
                "subject": "Emne",
                "body": "Melding"
            },
            "requiredFieldsWarning": "Vennligst fyll ut {fields} eller fjern e-poststeget."
        },
        "enterDescription": "Skriv inn beskrivelse",
        "enterEmail": "Skriv inn E -post",
        "enterName": "Skriv inn navn",
        "environment": "Miljø",
        "event": {
            "eventConfiguration": "Event Configuration",
            "title": "Event"
        },
        "excel": {
            "selectAll": "Velg alle",
            "showSelected": "Vis valgte",
            "fromSource": "Fra {source}",
            "chooseTheFile": "Velg en fil",
            "columnStyleApplied": "Kolonne Stil applied to Kolonne",
            "columnToLeft": "Legg til kolonne til venstre",
            "columnToRight": "Legg til kolonne til høyre",
            "controlSpreadSheet": "Kontroll regneark",
            "descriptionRow": "Beskrivelsesrad",
            "mappingRow": "Kartleggingsrad",
            "dataRow": "Data rad",
            "unsetMappingRow": "Fjern markering som kartleggingsrad",
            "setMappingRow": "Marker som kartleggingsrad",
            "setDescriptionRow": "Marker som beskrivelsesrad",
            "deleteCell": "Slett Celle",
            "deleteConfirmation": "Slett Bekreftelse",
            "deleteContent": "Slett Innhold",
            "deleteDesignFile": "Slett design fil",
            "deleteDesignFileConfirmation": "Bekreft om du vil fortsette og slette design filen.",
            "deleteInputItem": "Vil du fjerne {item} fra kartleggingsdelen av API Editor?",
            "deleteOutputItem": "Vil du fjerne {item} fra kartleggingen?",
            "designFileAlert": "Bekreft opplastingen ved å lagre arbeidsflyten",
            "endColumn": "Slutt kolonne",
            "enforceSheetVerification": "Håndheve arkbekreftelse",
            "environment": "Show used environment on execution",
            "environmentMessageColumn": "Environment Message Column",
            "excelSetting": "Excel innstilling",
            "excelSettings": "Innstillinger",
            "importWorkflowRequiredMessage": "For å bruke Excel-tilordning for inndata må denne arbeidsflyten konfigureres som en importarbeidsflyt.\nVil du aktivere importarbeidsflyt?",
            "groupBy": "Grupper etter",
            "headerRow": "Topptekst rad",
            "input": "Inngang",
            "messages": {
                "mapField": "EXCEL: Kart {input} feltet for excel",
                "mapOneInputFieldExcel": "EXCEL: Kart minst ett inndatafelt for excel",
                "mapOneOutputFieldExcel": "EXCEL: Kart minst ett utdatafelt for excel"
            },
            "next": "Neste",
            "options": "Alternativer",
            "output": "Produksjon",
            "removeGroupBy": "Fjerne grupper etter",
            "removeSortBy": "Remove sort by",
            "removeTargetSheet": "Fjern Målarket",
            "rowStyleApplied": "Rad Stil søkt på Rad",
            "saveBackup": "Lagre backup av utdata",
            "secondaryHeaderRow": "Sekundær Topptekst rad",
            "selectDifferentSheets": "Vennligst Velg forskjellige ark som kilde- og målark",
            "sheetName": "Ark Navn",
            "sortBy": "Sorter etter",
            "sourceSheet": "Kilde Ark",
            "startColumn": "Start kolonne",
            "style": "Stil",
            "styleHeader": "Påfør Stil til topptekst",
            "targetSheet": "Mål Ark",
            "title": "Excel",
            "toggleHeader": "Bytt Topptekst",
            "twoHeaders": "To Topptekst",
            "upload": "Laste opp",
            "showMappingValues": "Vis kartleggingsverdier",
            "hideMappingValues": "Skjul kartleggingsverdier",
            "horizontalNoLeftColumn": "Horisontal layout krever en kolonne til venstre for slippcellen for feltetiketten",
            "workflow": "Arbeidsflyt",
            "workflowMessageColumn": "Arbeidsflyt Meldings Kolonne",
            "template": {
                "singleHeader": "Én topptekst",
                "doubleHeader": "To topptekster"
            },
            "preview": {
                "sourceSheet": "Kildeark",
                "headerRow": "Mapping row",
                "secondaryHeaderRow": "Description row",
                "dataRow": "Datarader",
                "applyTooltip": "Kartleggings- eller beskrivelserrader er endret. Klikk her for å kjøre automapping på nytt.",
                "startColumn": "Startkolonne",
                "endColumn": "Sluttkolonne",
                "targetSheet": "Målark",
                "addTargetSheet": "Legg til målark",
                "removeTargetSheet": "Fjern målark",
                "targetSheetWarning": "Kilde- og målark kan ikke være de samme. Vennligst velg forskjellige ark for kilde og mål.",
                "sheetView": "Arkvisning",
                "sourceLabel": "Kilde",
                "targetLabel": "Mål",
                "validation": {
                    "headerOrMappingRequired": "At least one of Description or Mapping row is required.",
                    "headerAndMappingSameRow": "Description and Mapping rows cannot be the same.",
                    "dataRowAfterHeader": "Data Row must come after the Description row.",
                    "dataRowAfterMapping": "Data Row must come after the Mapping row.",
                    "applyRowsZero": "Radnumre skal ikke være null eller mindre enn null.",
                    "applyRowsConflict": "Dataraden må komme etter Beskrivelse- og Kartleggingsradene.",
                    "unappliedRowChangesSource": "Kildefanen har ubekreftede radendringer. Klikk ✓ for å bruke dem.",
                    "unappliedRowChangesTarget": "Målfanen har ubekreftede radendringer. Bytt til Målfanen og klikk ✓ for å bruke dem.",
                    "unappliedRowChangesBoth": "Begge fanene har ubekreftede radendringer. Klikk ✓ på hver fane for å bruke dem."
                }
            },
            "editCell": "Rediger celle",
            "largeColumnCountWarning": "Du har kartlagt et stort antall kolonner ({count}). Dette kan overskride systemgrensene og føre til at lagringen mislykkes."
        },
        "m3Api": {
            "unmappedRequiredInputs": "Følgende obligatoriske inndata er ikke tilordnet: {inputs}",
            "removeStartEnd": "Deaktiver start-slutt",
            "addStartEnd": "Aktiver start-slutt",
            "updateGrouping": "Ekstra gruppering",
            "existingGroupings": "Grupperinger på feltnivå",
            "extraGroupings": "Ekstra gruppering",
            "apiGroupings": "API-elementgrupperinger",
            "groupBy": "Grupper etter dette feltet",
            "hasGrouping": "Resultatet vil bli gruppert etter dette feltet",
            "runStartEndTitle": "Definer start-slutt-kjøring",
            "selectTag": "Velg tagg",
            "defineStartEnd": "Definer start-slutt-kjøring",
            "start": "Start transaksjon",
            "end": "Avslutt transaksjon",
            "deleteDependency": "Fjern avhengighet",
            "fail": "mislykkes",
            "success": "kjøres vellykket",
            "condition": "Betingelse",
            "selectTransaction": "Transaksjon",
            "dependency": "Kjør \"{apiLabel}\" hvis",
            "updateDependency": "Avhengigheter",
            "deleteOutput": "Slett utdata - dette feltet vil ikke være tilgjengelig i oppslag",
            "addOutput": "Legg til utdata - dette feltet vil bli tilgjengelig i oppslag",
            "sources": {
                "CONSTANT": "Konstant",
                "CLIENT": "Klient",
                "API": "API",
                "EXCEL": "Excel",
                "TEXT": "Tekst",
                "EVENT": "Hendelse",
                "CONTEXT": "Kontekst",
                "TAG": "Tagg",
                "CURRENT_DATE": "Dagens dato",
                "_": "Ingen"
            },
            "openFieldConfig": "Åpne konfigurasjon for parametertilordning",
            "client": "Hent verdi fra",
            "newClientField": "Nytt klientfelt",
            "showGeneralTransactions": "Inkluder generelle transaksjoner",
            "parameterRequiredAndNotMapped": "Parameter er obligatorisk men ikke tilordnet",
            "parameterNotRequiredAndNotMapped": "Parameter er ikke obligatorisk og ikke tilordnet",
            "apiCall": "API-kall",
            "output": "Utdata-parameter",
            "mappedOutputHeader": "Tilordnet utdata",
            "selectApiFirst": "Velg API først",
            "constantValue": "Konstant verdi",
            "constantValueRequired": "Konstant verdi er påkrevd",
            "tagRequired": "Tagg er påkrevd",
            "availableSources": "Tilgjengelige kilder",
            "selectSource": "Velg kilde",
            "removeSource": "Fjern kilde",
            "sourceTitle": "Feltkonfigurasjon for {name}",
            "copyPrefix": " (kopi %n)",
            "deleteApiConfirmation": "Er du sikker på at du vil slette API-kallet?",
            "deleteApiHeader": "Sletting av API-kall",
            "source": "Kilde",
            "value": "Verdi",
            "m3Company": "M3-selskap",
            "m3Division": "M3-divisjon",
            "maxRows": "Maks antall rader",
            "unlimited": "Ubegrenset",
            "companyMustBeNumeric": "M3-selskap må være en numerisk verdi",
            "executionConfig": "Kjøringskonfigurasjon",
            "name": "Navn",
            "configureExecution": "Konfigurer kjøring",
            "addFirstApi": "Klikk her for å legge til første API-kall",
            "noEnvironmentSelected": "Ingen miljøer valgt",
            "selectEnvironment": "Velg miljø",
            "transactionSelectTitle": "Velg transaksjon som skal kjøres",
            "program": "Programmer",
            "selectProgram": "Velg program først",
            "transaction": "Transaksjoner",
            "copy": "Kopier",
            "setCritical": "Sett som kritisk",
            "unsetCritical": "Fjern kritisk status",
            "inputsHeader": "Inndata",
            "outputHeader": "Utdata",
            "addItem": "Legg til API-element på denne posisjonen",
            "eventColumn": "Event column",
            "title": "M3 API",
            "selected": "valgt"
        },
        "execute": {
            "advanced": "Avansert",
            "browse": "Bla",
            "chooseTheFile": "Velg en fil",
            "dropTheFile": "Slipp filen her...",
            "logLevel": "Logg Nivå",
            "logLevelList": {
                "detailed": "Detaljert",
                "failures": "Svikt",
                "info": "Info"
            },
            "result": {
                "done": "Ferdig",
                "duration": "Varighet",
                "failedRecords": "Mislykkede poster:",
                "files": "Filer",
                "recordsProcessed": "Opptegnelser behandlet:",
                "stepId": "Trinn ID",
                "success": "Trinnsuksess:",
                "successfulRecords": "Vellykkede poster:",
                "title": "Resultater",
                "trigger": "Trigger File",
                "waitingToStart": "Venter på å starte",
                "workflowEnded": "Arbeidsflyt endte",
                "workflowFailed": "Arbeidsflyten mislyktes!",
                "workflowRunning": "Arbeidsflyt løping...",
                "workflowRunningInBackground": "Arbeidsflyt er fortsatt kjører i bakgrunnen. (Snart vil du kunne se kjøringsloggen for alle henrettelser)",
                "workflowStarted": "Arbeidsflyten startet",
                "failedToDownloadTriggerFile": "Kunne ikke laste ned triggerfil",
                "noTriggerFile": "Ingen triggerfil tilgjengelig"
            },
            "schedule": {
                "daily": {
                    "day": "dag",
                    "title": "Daglig"
                },
                "day": "Dag",
                "every": "Hver eneste",
                "everyWeekDay": "Hver ukedag",
                "hourly": {
                    "hour": "hour",
                    "title": "Hourly"
                },
                "minutes": {
                    "minutes": "minutter",
                    "title": "Minutter"
                },
                "monthly": {
                    "month": "mes",
                    "title": "Månedlig"
                },
                "monthsOptions": {
                    "april": "April",
                    "august": "August",
                    "december": "Desember",
                    "february": "februar",
                    "january": "Januar",
                    "july": "Juli",
                    "june": "Juni",
                    "march": "Mars",
                    "may": "Mai",
                    "november": "November",
                    "october": "Oktober",
                    "september": "September"
                },
                "of": "av",
                "ofEvery": "av hver",
                "periodOptions": {
                    "first": "Først",
                    "fourth": "Fjerde",
                    "second": "Sekund",
                    "third": "Tredje"
                },
                "scheduler": "Planlegger",
                "startTime": "Start tid",
                "the": "De",
                "weekly": {
                    "friday": "Fredag",
                    "monday": "Mandag",
                    "saturday": "Lørdag",
                    "sunday": "Søndag",
                    "thursday": "Torsdag",
                    "title": "Ukentlig",
                    "tuesday": "Tirsdag",
                    "wednesday": "Onsdag"
                },
                "yearly": {
                    "title": "Årlig"
                }
            }
        },
        "export": "Eksport",
        "failure": "Feil",
        "fileLoader": {
            "fileLoader": "File Loader",
            "messages": {
                "info": "If the folder has multiple files, the most recently edited will be picked by default",
                "missingConnection": "FILE LOADER: Please select a connection",
                "missingFile": "FILE LOADER: Please select a file"
            }
        },
        "filter": {
            "action": "Handling",
            "all": "Alle",
            "field": "Jorde",
            "fieldSource": {
                "constant": "Konstant",
                "fromClient": "Fra Klient"
            },
            "filterConditions": {
                "blank": "Er blank",
                "contains": "Inneholder",
                "doesNotContain": "Inneholder ikke",
                "equal": "Lik",
                "greaterThan": "Større Enn",
                "greaterThanEqual": "Større enn Lik",
                "lessThan": "Mindre Enn",
                "lessThanEqual": "Mindre enn Lik",
                "notBlank": "Er Ikke Blank",
                "notEqual": "Ikke Lik"
            },
            "filterConfiguration": "Filter konfigurasjon",
            "logicalType": "Logisk Type",
            "logicalTypes": {
                "and": "OG",
                "or": "ELLER"
            },
            "messages": {
                "mapOneFieldFilter": "M3-FILTER: Tilordne minst ett felt for at filteret skal fungere",
                "missingConstantValue": "FILTER: Missing value for Constant in {filterDescription}",
                "missingLogicalType": "FILTER: Missing Logical Type for {filterDescription}",
                "missingSource": "FILTER: Missing source for {filterDescription}",
                "missingType": "FILTER: Missing Type for {filterDescription}"
            },
            "noApiFound": "Fant ingen API",
            "selectFields": "Velg Enger",
            "source": "Kilde",
            "type": "Type"
        },
        "filterText": "Filter",
        "filters": "Filtre",
        "import": "Import",
        "inputFields": "Inndatafelt",
        "invalidWorkflow": "Ugyldig arbeidsflyt",
        "lastExecuted": "Sist henrettet",
        "logLevel": "Logg Nivå",
        "logLevelList": {
            "detailed": "Detaljert",
            "failures": "Svikt",
            "info": "Info"
        },
        "logs": {
            "AvgTimePerRecord": "AvgTimePerRecord",
            "AvgTimePerTransaction": "AvgTimePerTransaction",
            "action": "Handling",
            "auditLogs": "Audit Logs",
            "downloadDataContents": "Last ned datainnhold",
            "durationMs": "Varighet (ms)",
            "endTime": "Slut tid",
            "environmentLogs": {
                "rerunEnvironment": {
                    "title": "Confirm Re-run"
                }
            },
            "fails": "Mislykket",
            "joblog": "Jobb Logg",
            "logDetails": "Logg detaljer",
            "logType": "Logg Type",
            "logTypeList": {
              "all": "Alle",
              "failed": "Feilet",
              "ok": "Vellykket",
              "verified": "Verifisert",
              "retried": "Forsøkt på nytt",
              "started": "Startet"
            },
            "logs": "Tømmerstokker",
            "message": "Beskjed",
            "program": "Program",
            "startTime": "Start tid",
            "status": "Status",
            "success": "Suksess",
            "time": "Tid",
            "title": "Arbeidsflyt logger",
            "transaction": "Transaksjon",
            "type": "Type",
            "rerun": "Kjør workflow på nytt",
            "verify": "Marker som verifisert",
            "resultJson": {
                "errorTitle": "Kunne ikke laste ned resultatdetaljer",
                "download": "Last ned resultatdetaljer",
                "copyToClipboard": "Kopier til utklippstavle",
                "copySuccessMessage": "Resultatdetaljer kopiert til utklippstavle",
                "copyErrorMessage": "Feil ved kopiering av resultatdetaljer til utklippstavle"
            },
            "findOriginal": "Finn original"
        },
        "manual": "Håndbok",
        "messages": {
            "configureOneComponent": "Vennligst konfigurere minst en komponent",
            "couldNotSaveWorkflow": "Kunne ikke lagre arbeidsflyten!",
            "enterNotificationEmail": "Vennligst Tast inn varsling E-post",
            "enterValidWorkflow": "Vennligst Skriv inn et gyldig arbeidsflyt navn.",
            "errorOccured": "Det oppsto en feil under utførelsen av arbeidsflyten!",
            "executionComplete": "Utførelsen fullført!",
            "fileNotFound": "File or directory not found. Please check if the uploaded file exists or has been renamed.",
            "invalidGenericFilter": "Vennligst velg logisk type for alle radene i Generisk filter",
            "invalidValue": "Ugyldig verdi %{input} for feltet %{field}.",
            "m3APIMaxRowAlertText": "Hvis du vil ha mer enn 99 999 poster, huk av for \"Ubegrenset\".",
            "mandatoryField": "Vennligst Skriv inn det obligatoriske feltet %{field}.",
            "maxValueExceed": "Verdi {input} for feltet {field} har overskredet maksimal lengde {length}.",
            "permissionError": "Bruker/rolle har ikke tillatelser til {errorMessage}",
            "schdulerSavedWithErrors": "Det oppstod en feil i planleggerkonfigurasjonen",
            "schedulerDelete": "Planlegger slettet vellykket",
            "schedulerErrorAlertText": "{input} har manglende verdier",
            "schedulerSavedSuccessfully": "Planlegger konfigurert med suksess",
            "specialCharError": "Spesialtegn / $ *? {'{ }'} [] ikke tillatt i arbeidsflytnavn",
            "workflowNameExists": "Arbeidsflyt navn {workflowName} eksisterer allerede!",
            "workflowNameRequired": "Workflow name is required",
            "workflowSavedSuccessfully": "Arbeidsflyt lagret vellykket!",
            "workflowSavedWithErrors": "Arbeidsflyt lagret med følgende feil:"
        },
        "modifiedBy": "Modified by",
        "name": "Navn",
        "navguardWarning": "You seem to have unsaved changes that will be lost if you leave this page. Do you wish to discard the changes and continue?",
        "newWorkflow": "Ny Arbeidsflyt",
        "notificationEmail": "E-post for feilrapporter",

        "notifyOnErrorTooltip": "Varsler mottaker(e) ved hver feil",

        "notificationEmailHint": "Skriv inn én eller flere e-postadresser, atskilt med komma. Brukes både for feilvarsler når «Varsle ved feil» er merket av, og for generelle feil som flere mislykkede planlagte kjøringer.",
        "executionLogs": "Utførelseslogger",
        "executionKeys": "Utførelsesnøkler",
        "deleteWorkflow": "Slett Arbeidsflyt",
        "deactivateWorkflow": {
            "header": "Deaktiver arbeidsflyt",
            "message": "Deaktivering av denne arbeidsflyten vil også stoppe planlagte kjøringer.",
            "confirm": "Ja, deaktiver"
        },
        "workflowActivatedSuccess": "Arbeidsflyt aktivert",
        "workflowDeactivatedSuccess": "Arbeidsflyt deaktivert",
        "groups": "grupper",
        "group": "gruppe",
        "label": "etikett",
        "notifyOnError": "Varsle ved feil",
        "addActive": "Legg til valgte",
        "addAllActive": "Legg til alle",
        "removeActive": "Fjern valgte",
        "removeAllActive": "Fjern alle",
        "moveUp": "Flytt valgt element opp",
        "moveTop": "Flytt valgt element til toppen",
        "moveDown": "Flytt valgt element ned",
        "moveBottom": "Flytt valgt element til bunnen",
        "outputFields": "Utdatafelt",
        "preview": "Forhåndsvisning",
        "previewData": "Forhåndsvis Data",
        "recentlyViewed": "Nylig sett",
        "favorite": "Legg til favoritter",
        "unfavorite": "Fjern fra favoritter",
        "favorites": "Favoritter",
        "restApi": {
            "restApiConfiguration": "Rest API"
        },
        "runBy": "Run by",
        "scheduled": "Planlagt",
        "select": "Å velge",
        "settings": {
            "retryAttemptsNegetiveNumberValidation": "Bør ikke være under 0",
            "retryAttemptsPositiveNumberValidation": "Bør ikke overskride grensen 5."
        },
        "sms": {
            "maxlengthWarning": "{messageLength}/160 tegn",
            "messages": {
                "contentMaxLengthError": "SMS: content cannot exceed 160 characters",
                "invalidRecipientNumber": "Ugyldig telefonnummer",
                "noContentError": "SMS: Content field cannot be blank",
                "noRecipientsError": "SMS: Recipients cannot be empty"
            },
            "recipientsLabel": "Skriv inn mottakerens telefonnummer",
            "recipientsPlaceholder": "+1234567890",
            "smsConfiguration": "SMS Configuration",
            "smsContentPlaceholder": "Enter the message",
            "smsLabel": "Beskjed",
            "saveMessage": "Lagre melding"
        },
        "status": {
            "active": "Aktiv",
            "all": "Alle",
            "inactive": "Inaktiv",
            "title": "Status"
        },
        "success": "Suksess",
        "table": {
            "columnName": "Kolonne Navn",
            "columnToLeft": "Legg til Kolonne til venstre",
            "columnToRight": "Legg til Kolonne til høyre",
            "customTableConfig": "Skikk Tabell config",
            "dataType": "Data type",
            "deleteCell": "Slett Celle",
            "deleteContent": "Slett Innhold",
            "fieldName": "Felt Navn",
            "messages": {
                "missingPrimaryKey": "TABELL: Tabell er mangler Primær nøkkel",
                "missingRecordCreationType": "TABELL: Tabell mangler Record Creation typen",
                "missingTableName": "TABELL: Manglende Tabell navn",
                "tableNameExists": "TABELL: Tabelle navn eksisterer allerede"
            },
            "primaryKey": "Primær nøkkel",
            "recordTypeList": {
                "append": "Append",
                "replace": "Erstatt",
                "upsert": "Upsert"
            },
            "removeField": "Fjern felt",
            "removePrimaryKey": "Fjern Primær Nøkkel",
            "selectFields": "Velg Enger",
            "setPrimaryKey": "Angi Primær Nøkkel",
            "tableAlias": "Table Alias",
            "tableDescription": "Tabell Beskrivelse",
            "tableName": "Tabell Navn",
            "tableRecordType": "Ta opp opprettelse type",
            "tableSettings": "Tabell innstillinger",
            "showRecentWorkflows": "Vis nylig viste arbeidsflyter",
            "hideRecentWorkflows": "Skjul nylig viste arbeidsflyter",
            "sortByFavorites": "Sorter etter favoritter",
            "clearFavoriteSort": "Fjern favorittsortering"
        },
        "tableUpdater": {
            "messages": {
                "noTableSelectedWarning": "Table Updater: Please select a table.",
                "stepInfo": "Please note that the output from the previous step needs to have the keys marked with (P)."
            },
            "selectTableLabel": "Select a table",
            "tableUpdaterConfiguration": "Table updater"
        },
        "converter": {
            "saveAsFile": "Lagre utdata som fil i tillegg"
        },
        "title": "Arbeidsflyter",
        "transform": {
            "transformConfiguration": "Transform",
            "trimAllInputValues": "Trim all input values before transformation"
        },
        "m3filter": {
            "newValue": "Verdi",
            "newConstant": "Ny",
            "noM3ApiItems": "Ingen filterelementer tilgjengelig uten definert M3 API",
            "dragItems": "Filteret har for øyeblikket ingen elementer.",
            "clickToShow": "Klikk her for å vise tilgjengelige felter",
            "dropBelow": "Dra elementet nedenfor for å legge til filter",
            "filterItems": "Filterelementer",
            "globalFilter": "Globalt filter",
            "constant": "Konstant",
            "defaultValue": "Standardverdi",
            "valueSourceOptions": {
                "CLIENT": "Klient",
                "CONSTANT": "Konstant"
            },
            "comparisonOptions": {
                "EQ": "Lik",
                "NE": "Ikke lik",
                "LT": "Mindre enn",
                "GT": "Større enn",
                "LE": "Mindre eller lik",
                "GE": "Større eller lik",
                "BLANK": "Tom",
                "NOTBLANK": "Ikke tom",
                "CONTAINS": "Inneholder",
                "NOTCONTAINS": "Inneholder ikke"
            },
            "source": "Kilde",
            "logicalOperator": "Logisk operator",
            "comparison": "Sammenligning",
            "title": "Filter",
            "openFields": "Vis tilgjengelige felter",
            "closeFields": "Lukk feltlisten",
            "constantValueRequired": "Konstant verdi er påkrevd for felt: {field}",
            "noFieldsMappedWarning": "Ingen felter er kartlagt. Kartlegg minst ett felt for M3-filteret eller fjern M3-filteret."
        },
        "trigger": {
            "apiSettingDetails": "Detaljer for API-innstillinger",
            "templateName": "Malnavn",
            "buttonLabel": "Knappetekst",
            "buttonPreview": "Forhåndsvisning",
            "dropArea": "Dra-og-slipp-område for {group}",
            "emptyDropArea": "Dra og slipp",
            "allFieldsAssigned": "Alle tilgjengelige felter er tilordnet.",
            "removeFieldToMakeAvailable": "Fjern et felt for å gjøre det tilgjengelig igjen.",
            "allFiltersAssigned": "Alle tilgjengelige filtre er tilordnet.",
            "removeFilterToMakeAvailable": "Fjern et filter for å gjøre det tilgjengelig igjen.",
            "lookupConfig": "Konfigurer oppslag",
            "clientPreview": "Klientforhåndsvisning",
            "lookupAlreadyExists": "Trigger: Lookup navn eksisterer allerede!",
            "lookupNameRequired": "Trigger: Lookup navn er påkrevd",
            "selectNewWorkflow": "Velg en ny arbeidsflyt for å endre triggerens arbeidsflyt",
            "selectSource": "Velg Kilde",
            "lookupNotAvailable": "Søk er ikke tilgjengelig. Arbeidsflyten ble ikke funnet eller er inaktiv.",
            "workflowNotFound":"Den valgte arbeidsflyten er utilgjengelig. Vennligst velg en ny arbeidsflyt.",
            "noClientInputs": "Ingen klientinnganger er konfigurert for denne triggeren",
            "actions": "Handlinger",
            "actionsRequired": "Actions is a mandatory field",
            "messages": {
                "triggerType": "TRIGGER: Please select a Trigger Type"
            },
            "title": "Trigger",
            "triggerConfiguration": "Trigger Configuration",
            "filtering": "Filtrering",
            "filterTooltip": "Du kan bare ha Filter eller Uttrykk. Hvis du velger ett av dem, fjernes det andre",
            "emptyFilterPlaceholder": "Ingen filtre eller uttrykk er brukt. Klikk på Filtre eller Uttrykk for å lage en betingelse. Å velge en vil fjerne den andre",
            "addFilter": "Legg til filter",
            "maximizeEditor": "Maksimer editor",
            "invalidExpression": "Ugyldig JSONata-uttrykk",
            "events": {
                "FILTER": "Filter",
                "EXPRESSION": "Uttrykk"
            },
            "nextRuns": "Neste planlagte kjøringer",
            "start": "Startdato/-klokkeslett",
            "end": "Sluttdato/-klokkeslett",
            "scheduledWorkflowRuns": "Planlagte arbeidsflytkjøringer",
            "scheduleDescription": "Angi hvor ofte du vil at arbeidsflyten skal kjøre",
            "scheduledRuns": "Planlagte kjøringer",
            "noScheduledRuns": "Ingen planlagte kjøringer",
            "clearSelection": "Fjern valg",
            "replaceNotAvailable": "Utløserhendelser er ikke tilgjengelige for REPLACE",
            "noEventColumnsAvailable": "No event columns available. Please configure an Event trigger with columns first."
        },
        "updateUserInstructions": "Oppdater",
        "userInstructions": "Brukerinstruksjoner",
        "saveUserInstructions": "Instruksjonene ble lagret",
        "value": "Verdi",
        "version": "Versjon",
        "searchEnvironments": "Search environments",
        "loadErrorEnvironments": "Kunne ikke laste inn miljøer",
        "loadErrorEnvironmentsPermission": "Du har ikke tillatelse til å laste inn miljøer. Kontakt administratoren din.",
        "loadErrorConnections": "Kunne ikke laste inn tilkoblinger",
        "loadErrorConnectionsPermission": "Du har ikke tillatelse til å laste inn tilkoblinger. Kontakt administratoren din.",
        "templates": {
            "exportToExcel": {
                "title": "Export from M3 API",
                "description": "Export from a M3 API through a filter into a table"
            },
            "importToApi": {
                "title": "Import to M3 API",
                "description": "Import from the M3 API into a table"
            },
            "apiToTable": {
                "title": "Store data from M3 to Table",
                "description": "Export from the M3 API into a table"
            },
            "onAPI": {
                "title": "M3 API",
                "description": "Connect directly to the M3 API"
            },
            "transform": {
                "title": "Transform",
                "description": "Process and transform data between systems"
            },
            "empty": {
                "title": "Blank Start",
                "description": "Build a workflow from scratch"
            }
        },
        "templateGroups": {
            "multi": "Multi Component Templates",
            "single": "Single Component Templates"
        },
        "nameAndDescription": "Details",
        "template": "Templates",
        "labels": "Étiquettes",
        "addLabel": "Add a Label",
        "workflowInfo": "Workflow Info",
        "configuration": "Configuration",
        "options": "Options",
        "widget": {
            "addNewState": "Legg til ny tilstand",
            "additionalInfo": "Color for foreground text and icon",
            "aggregateType": "Aggregate Type",
            "backgroundColor": "Background color",
            "color": "Farge",
            "count": "Count",
            "createWidget": "Lag widget",
            "customBackgroundColor": "Custom background color",
            "dashboardUpdateInterval": "Dashboard oppdatering intervall(sekunder)",
            "data": "Data",
            "dataCount": "Font size for data count",
            "defaultBackgroundColor": "Default background color",
            "deleteDraft": "Slett utkast",
            "displayValue": "Visningsverdi",
            "documentation": "Dokumentasjon",
            "editState": "Rediger tilstand",
            "fontSize": "Skrift Størrelse",
            "foregroundColor": "Text color",
            "icon": "Ikon",
            "iconSettings": "Ikon konfig",
            "interval": "Intervall",
            "label": "Merkelapp",
            "labelsMax": "Etiketter (max 25)",
            "max": "Maks",
            "min": "Min",
            "newState": "Ny stat",
            "noStatesDefined": "Ingen stater er definert",
            "normalized": "Normalisert",
            "pollingCountWithoutChanges": "Avstemning uten endringer før advarsel",
            "range": "Spekter",
            "rangeFrom": "Spenner fra",
            "rangeTo": "Rekkevidde til",
            "scales": "Scales",
            "selectWidgetType": "Velg widgettype",
            "show": "Vise fram",
            "sortBy": "Sorter Etter",
            "stacked": "Stablet",
            "states": "Stater",
            "tableName": "Tilpassede Tabeller",
            "titleSize": "Header font size",
            "type": "Type",
            "viewDetails": "Vis detaljer",
            "widgetField": "Jorde",
            "widgetTitle": "Tittel",
            "xAxisConfigure": "Konfigurer X-akse",
            "yAxisConfigure": "Konfigurer Y-aksen"
        },
        "workflow": "Arbeidsflyt",
        "workflowActions": {
            "downloadTemplate": "Last ned Mal",
            "execute": "Henrette",
            "log": "logg",
            "manageRoles": "Administrer roller",
            "move": "Bevege seg",
            "reRun": "Re-run",
            "rename": "Gi nytt navn",
            "run": "Run",
            "schedule": "Tidsplan"
        },
        "workflowDescription": "Arbeidsflyt beskrivelse",
        "copyInfo": "Du kan enten endre arbeidsflytnavnet eller bruke det foreslåtte navnet for å fortsette.",
        "copyWorkflow": "Kopier arbeidsflyt",
        "enterCopyName": "Arbeidsflytnavn",
        "nameExists": "Arbeidsflytnavnet er allerede i bruk. Vennligst velg et unikt navn.",
        "copySuccess": "Arbeidsflyten '{name}' ble kopiert.",
        "copyError": "Kunne ikke kopiere workflow",
        "workflowName": "Arbeidsflyt navn",
        "workflowType": "Workflow Type",
        "workflowTypeOptions": {
            "EXPRESS": "Ekspress",
            "STANDARD": "Høyt volum"
        },
        "useDedicatedIP": "Bruk dedikert IP",

        "ignoreExportMi": "Ignorer EXPORTMI-oppslag",
        "longRunning": "Langvarig kjøring",
        "longRunningMessage": "Håndterer langvarige og høy-kapasitets arbeidsbelastninger",
        "expressMessage": "God for raske operasjoner, men kan feile ved lange eller tunge arbeidsbelastninger på grunn av kjøretidsbegrensninger.",
        "longRunningTooltip": "Aktiver for store Excel-importer (30 000+ rader) som kan overstige 15 minutter."
    },
    "workflowStatistics": {
        "statistics": "Arbeidsflytstatistikk",
        "lastExecutionTime": "Siste kjøringstid",
        "lastSuccessfulTime": "Siste vellykkede kjøring",
        "lastFailedTime": "Siste mislykkede kjøring",
        "totalRuns": "Totalt antall kjøringer",
        "totalRunsTooltip": "Totalt antall arbeidsflytkjøringer",
        "successfulRunsTooltip": "Vellykkede arbeidsflytkjøringer",
        "failedRunsTooltip": "Mislykkede arbeidsflytkjøringer",
        "viewLog": "Vis logg"
    }
}
